<template>
  <div v-if="results">
    <div class="calc-results">

      <h2 class="calc-results__title">Calculadora Custo para tirar CNPJ</h2>

      <label class="calc-results__subtitle">
        Confira abaixo o resultado:
      </label>

      <div
        id="entenda-o-calculo"
        class="calc-results__result"
      >
        <div class="calc-results__table">
          <ul class="calc-results__table__firstcol">
            <li>&nbsp;</li>
            <li class="calc-results__table__gray-light">
              <span class="light-bold">Junta comercial</span>
              <TooltipText
                :text="'Pagamento do DARE, taxa destinada ao registro público da sua empresa'"
                :class-name="'marginl-40'"
                class="calc-results__tooltip"
              />
            </li>
            <li>
              <span class="light-bold">Certificado digital</span>
              <TooltipText
                :text="'Necessário para confirmar a autenticidade da empresa que emite nota fiscal eletrônica.'
                +'Na Contabilizei, o certificado digital é gratuito a partir do plano Padrão'"
                :class-name="'marginl-40'"
                class="calc-results__tooltip"
              />
            </li>
            <li>
              <span class="light-bold">Serviço de abertura de empresa</span>
              <TooltipText
                :text="'Na Contabilizei o serviço de abertura empresa é grátis e você só pagará as taxas do governo e realiza os protocolos físicos.'"
                :class-name="'marginl-40'"
                class="calc-results__tooltip"
              />
            </li>
            <li class="calc-results__table__gray-medium calc-results__table__bottom-left">
              <span class="light-bold ">Custo total</span>
            </li>
          </ul>

          <ul class="calc-results__table__secondcol">
            <li>Sem a <span class="bold">Contabilizei</span></li>
            <li class="calc-results__table__gray-light">
              <span>
                {{ formatNumber(results.data.taxas.semContabilizei.itens.juntaComercial) }}
              </span>
            </li>
            <li>
              <span>
                {{ formatNumber(results.data.taxas.semContabilizei.itens.certificadoDigital) }}
              </span>
            </li>
            <li>
              <span>
                {{ formatNumber(results.data.taxas.semContabilizei.itens.servicoAberturaEmpresa) }}
              </span>

            </li>
            <li class="calc-results__table__gray-medium">
              <span class="light-bold">
                {{ formatNumber(results.data.taxas.semContabilizei.total) }}
              </span>

            </li>
          </ul>

          <ul class="calc-results__table__thirdcol">
            <li class="calc-results__table__blue-light calc-results__table__top-right">Com a <span class="bold">Contabilizei</span></li>
            <li class="calc-results__table__blue-medium">
              {{ formatNumber(results.data.taxas.comContabilizei.itens.juntaComercial) }}
            </li>
            <li class="calc-results__table__blue-light">
              {{ formatNumber(results.data.taxas.comContabilizei.itens.certificadoDigital) }}
            </li>
            <li class="calc-results__table__blue-light">
              {{ formatNumber(results.data.taxas.comContabilizei.itens.servicoAberturaEmpresa) }}
            </li>
            <li class="calc-results__table__blue-medium calc-results__table__bottom-right">
              <span class="light-bold">
                {{ formatNumber(results.data.taxas.comContabilizei.total) === 'Grátis' ? 'R$ 0,00' :
                formatNumber(results.data.taxas.comContabilizei.total)
                }}
              </span>
            </li>
          </ul>
        </div>

      </div>

      <div class="col-12 calc-results__economia">
        <p>Com a Contabilizei você economiza até {{ formatNumber(results.data.taxas.semContabilizei.total) }}!</p>
      </div>

      <ListCollapseFaq
        :cor-texto="''"
        :cor-descricao="''"
        :track-position="-1"
        class="calc-results__considerations mt30"
      />

      <CalculatorResultsPlan />

      <h2  style="color:#002868; font-size: 24px;" class="calc-results__title-economia">
        Sabia que abrindo sua empresa de {{results.data.nomeAtividade}} você pode economizar em impostos?
      </h2>

      <p class="text-center">Confira o quanto você economizará tirando seu CNPJ em comparação aos impostos devidos como pessoa física.</p>

      <div class="calc-results__table-final">
        <ul class="calc-results__table-final__firstcol">
          <li
            class="
            calc-results__table-final__gray-light
            calc-results__table-final__top-left
            calc-results__table-final__flex-1
          "
          >
            <span class="light-bold">Faturamento mensal líquido</span>
          </li>
          <li>
            {{ formatNumber(results.data.pessoaJuridica.faturamentoLiquido) }}
          </li>
        </ul>

        <ul class="calc-results__table-final__secondcol">
          <li class="calc-results__table-final__gray-light calc-results__table-final__flex-1">
            <span class="light-bold">Imposto devido como pessoa física</span>
          </li>
          <li>
            {{ formatNumber(results.data.pessoaFisica.impostoRenda) }}
          </li>
        </ul>

        <ul class="calc-results__table-final__thirdcol">
          <li
            class="
            calc-results__table-final__blue-light
            calc-results__table-final__top-right
            "
          >
            <span class="light-bold">Imposto devido como pessoa jurídica</span>
          </li>
          <li
            class="
            calc-results__table-final__blue-medium
            calc-results__table-final__bottom-right
            "
          >
            {{ formatNumber(results.data.pessoaJuridica.impostoFaturamento) }}
          </li>
        </ul>
      </div>

      <div class="calc-results__final-step" v-show="!thankyou">
        <h2 style="color:#002868; font-size: 24px;" class="calc-results__title-pj">Vai trabalhar como PJ e precisa abrir empresa?
          Abra seu CNPJ de forma gratuita!</h2>

        <ButtomPrimary
          :disabled="false"
          :texto="'FALE COM UM ESPECIALISTA'"
          class="calc-results-plan__btn"
          :deepClass="'blue-light'"
          @click="thankyou = !thankyou"
        />
      </div>
      <div class="calc-results__thankyou" v-show="thankyou">
        <h2>Recebemos sua solicitação!</h2>
        <p>Logo um de nossos especialistas entrará em contato com você.</p>
      </div>
    </div>
  </div>
</template>

<script>

import CalculatorResultsPlan from '@/components/CalculatorResultsPlan'
import ListCollapseFaq from '@/components/ListCollapseFaq'
import TooltipText from '@/components/TooltipText'
import ButtomPrimary from '@/components/ButtomPrimary'

export default {
  components: {
    CalculatorResultsPlan,
    ListCollapseFaq,
    TooltipText,
    ButtomPrimary
  },
  data() {
    return {
      thankyou: false
    }
  },
  props: {
    results: {
      type: Object,
      default: () => null
    }
  },
  methods: {
    formatNumber(number) {

    if(number === 0) {
      return 'Grátis'
    }
    return this.formatCoinNumber(number)
    },

    formatCoinNumber(val) {
    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    return formatter.format(val);
    },
  }
}
</script>
<style lang="scss" src="./CalculatorResults.styles.scss" scoped></style>
